export default __webpack_public_path__ + "static/media/diamond.2e509738.svg";